module.exports = __webpack_public_path__ + "static/media/brand-logo-green.9f148eba.svg";